<mobi-breadcrumb />
<div class="mobi-ui-grid is-centered">
  <div
    class="max-w-full mobi-ui-col-1/1 mobi-ui-animation-appear-up-init mobi-ui-animation-appear-up-render is-delayed-300"
    [class]="{
      'xl:mobi-ui-col-3/4': headerImage(),
      'md:mobi-ui-col-2/3': !headerImage(),
      'xl:mobi-ui-col-1/2': !headerImage(),
    }"
  >
    @if (superTitle()) {
      <span class="mobi-ui-font-h4 mobi-ui-text-inked text-animation !pb-0">
        {{ superTitle() }}
      </span>
    }
    @if (title()) {
      <h1 class="mobi-ui-font-h1 text-animation">
        {{ title() }}
      </h1>
    }
  </div>
</div>

@if (headerImage()) {
  <div class="mobi-ui-grid is-centered pointer-events-none">
    <div class="hero-image mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
      <div
        class="relative"
        [class]="{
          'mb-[90px]': hasOverview() && (calculatorCta() || consultationCta()),
        }"
      >
        <div class="hero-image-animation-wrapper">
          <mobi-media
            [animation]="false"
            class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300 pointer-events-auto"
            rounded="full"
            [entity]="headerImage()"
            [mobileEntity]="headerImageMobile()"
            [responsiveStyle]="
              !calculatorCta() && !consultationCta()
                ? 'hero_single'
                : 'hero_single_product'
            "
            [lazy]="false"
          />
        </div>
        @defer (hydrate on idle) {
          @if (hasOverview() && (calculatorCta() || consultationCta())) {
            <div
              class="px-[8px] xs:px-[20px] md:px-0 absolute bottom-[-90px] left-0 right-0 z-[1]"
            >
              <div class="mobi-ui-grid is-centered">
                <div
                  class="max-w-full mobi-ui-col-1/1 mobi-ui-animation-appear-up-init mobi-ui-animation-appear-up-render is-delayed-300"
                  [class]="{
                    'md:mobi-ui-col-2/3': !oneCta(),
                    'md:mobi-ui-col-1/3': oneCta(),
                  }"
                >
                  <div class="mobi-ui-card-major is-large xsMax:!p-4 pointer-events-auto">
                    @if (isProtektaProduct()) {
                      <img
                        src="/logos/protekta.svg"
                        fetchpriority="auto"
                        decoding="async"
                        loading="lazy"
                        class="mb-4 w-fit h-4 md:h-6"
                        [attr.alt]="
                          'protekta_logo_label'
                            | texts: { context: 'frontend', default: 'Protekta' }
                        "
                      />
                    }
                    @if (subtitle()) {
                      <span
                        class="mb-[12px] xs:mb-[24px] mobi-ui-font-bold mobi-ui-font-realist mobi-ui-ink-black text-animation"
                      >
                        {{ subtitle() }}
                      </span>
                    }
                    @if (calculatorCta() || consultationCta()) {
                      <div
                        class="flex flex-col sm:flex-row gap-[12px] xs:gap-[20px] md:gap-[24px]"
                      >
                        @if (calculatorCta()) {
                          @if (hasPrerollout()) {
                            <button
                              type="button"
                              (click)="onCalculatorCtaClick($event)"
                              class="mobi-icon-cta mobi-cta-responsive-width mobi-cta-optout-full-md mobi-ui-btn-major is-squared justify-between mobi-ui-width-full mobi-ui-padding-y-xs !px-4 mobi-ui-animation-trigger-hover mobi-ui-animation-scale-up-init mobi-ui-animation-scale-up-hover flex-1 min-w-0 cursor-pointer"
                              style="height: auto; min-height: 64px"
                            >
                              <span class="mobi-ui-flex items-center">
                                <mobi-ui-icon-major
                                  name="calculator"
                                  class="!ml-0 mr-[12px]"
                                />
                                <span
                                  class="flex items-center justify-start text-align-left"
                                  >{{ calculatorCta()!.title }}</span
                                >
                              </span>
                              <mobi-ui-icon-major
                                name="right"
                                class="!m-0 mobi-ui-animation-horizontal-wiggle-hover-target !ml-auto"
                              />
                            </button>
                          } @else {
                            <mobi-icon-cta
                              [isPrimary]="true"
                              [url]="calculatorCta() | extractUrl"
                              [target]="calculatorCta()!.options?.attributes?.target"
                              [title]="calculatorCta()!.title"
                              icon="calculator"
                              class="block flex-1 min-w-0 calculator-cta mobi-ui-animation-appear-right-init mobi-ui-animation-appear-right-render mobi-cta-optout-full-md"
                            ></mobi-icon-cta>
                          }
                        }
                        @if (consultationCta()) {
                          <mobi-icon-cta
                            [isPrimary]="calculatorCta() ? false : true"
                            [url]="consultationCta() | extractUrl"
                            [title]="consultationCta()!.title"
                            [target]="consultationCta()!.options?.attributes?.target"
                            icon="message_conversation"
                            class="block consultation-cta mobi-ui-animation-appear-right-init mobi-ui-animation-appear-right-render flex-1 min-w-0 mobi-cta-optout-full-md"
                          ></mobi-icon-cta>
                        }
                      </div>
                    }

                    @if (
                      breakpoint.smMax() &&
                      (rating()?.count ?? 0) > 0 &&
                      rating()?.ratingPageUrl !== undefined
                    ) {
                      <a
                        class="mt-[12px] xs:mt-[24px] pointer-events-auto"
                        [betterRouterLink]="rating()!.ratingPageUrl ?? ''"
                      >
                        <ng-container [ngTemplateOutlet]="ratingTemplate" />
                      </a>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        }
        @if (
          (breakpoint.mdAndLarger() || (!calculatorCta() && !consultationCta())) &&
          (rating()?.count ?? 0) > 0 &&
          rating()?.ratingPageUrl !== undefined
        ) {
          <a
            class="left-auto right-4 ml-auto mr-auto w-fit absolute md:right-8 pointer-events-auto"
            [class]="{
              'bottom-4': !hasOverview() || (!calculatorCta() && !consultationCta()),
              'md:bottom-8': !hasOverview() || (!calculatorCta() && !consultationCta()),
              'top-4': hasOverview() && (calculatorCta() || consultationCta()),
              'md:top-8': hasOverview() && (calculatorCta() || consultationCta()),
            }"
            [betterRouterLink]="rating()!.ratingPageUrl ?? ''"
          >
            <ng-container [ngTemplateOutlet]="ratingTemplate" />
          </a>
        }
      </div>
    </div>
  </div>
}
<div class="mobi-ui-margin-t-xl">
  <mobi-hero-text
    [subtitle]="hasOverview() && (calculatorCta() || consultationCta()) ? '' : subtitle()"
    [lead]="lead()"
    [contentLinks]="contentLinks()"
    [otherLinks]="otherLinks()"
  ></mobi-hero-text>
</div>

@if (hasPrerollout()) {
  <mobi-prerollout-overlay
    #prerolloutOverlay
    [nodeId]="nodeId()!"
    [prerolloutUrl]="calculatorCtaPrer()?.uri?.path || ''"
    [regularUrl]="calculatorCta() | extractUrl"
    [ctaTarget]="calculatorCta()?.options?.attributes?.target"
    trackingContext="link"
    [trackingName]="calculatorCta()?.title || ''"
  />
}

<ng-template #ratingTemplate>
  <div
    class="flex flex-col items-center"
    [class.mobi-ui-card-major]="
      breakpoint.mdAndLarger() || (!calculatorCta() && !consultationCta())
    "
  >
    <mobi-star-rating
      [rating]="rating()?.average_rating"
      [starSize]="starSize()"
      [isInHeader]="true"
    ></mobi-star-rating>
    <span class="text-black text-center italic">
      {{ rating()?.count }}
      @if ((rating()?.count ?? 0) >= 2) {
        {{
          'customerOpinions' | texts: { context: 'frontend', default: 'Kundenmeinungen' }
        }}
      } @else {
        {{ 'customerOpinion' | texts: { context: 'frontend', default: 'Kundenmeinung' } }}
      }
    </span>
  </div>
</ng-template>
